import React, { useReducer } from 'react';

import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import * as yup from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import { COLORS } from '../../../Constant/COLORS';

import { useToastContext } from '../../../Context/ToastContext';

import PasswordField from '../../../Components/PasswordField';

import { useFormContext } from './FormContext';

import { PasswordChange } from '../../../Server/Query';
import { useNavigate } from 'react-router-dom';

function PasswordReset() {
  const { inputs, updateInputs } = useFormContext();
  const { showToastMessage } = useToastContext();
  const navigate = useNavigate();

  const [errors, updateErrors] = useReducer(
    (state, errors) => ({ ...state, ...errors }),
    { password: null, confirmPassword: null }
  );

  function handleChange(event) {
    const { name, value } = event.target;
    updateInputs({ [name]: value });
  }

  async function handleSubmit(event) {
    // try {
    //   event.preventDefault();
    //   updateErrors({ password: null, confirmPassword: null });
    //   const validatedInputs = await schema.validate(inputs, {
    //     abortEarly: false,
    //   });

    //   const query = PasswordChange({
    //     password: validatedInputs.password,
    //     email: inputs.email,
    //     user: 'PROFESSIONAL',
    //   });
    //   const response = await Axios({ query });

    //   if (response.errors) {
    //     showToastMessage('Something went wrong, Failed to verify your code');
    //     return undefined;
    //   }

    //   showToastMessage('Password reset successful', 'success');
    //   navigate('/professional/login');
    // } catch (error) {
    //   if (error instanceof yup.ValidationError) {
    //     const errors = error.inner.reduce(
    //       (errors, err) => ({ ...errors, [err.path]: err.message }),
    //       {}
    //     );
    //     updateErrors(errors);
    //     return undefined;
    //   }
    //   showToastMessage('Something went wrong');
    // }
  }

  return (
    <Stack
      px={{ xs: 2, md: 15 }}
      py={{ xs: 5, md: 5 }}
      component='form'
      onSubmit={handleSubmit}
    >
      <Typography
        textAlign='center'
        fontWeight={600}
        variant='h6'
        variantMapping={{ h6: 'h1' }}
      >
        Enter New password
      </Typography>
      <Typography textAlign='center' mb={4}>
        Please Enter your New password
      </Typography>

      <FormControl sx={{ mb: 2 }}>
        <Typography
          mb={1}
          fontWeight={500}
          component={FormLabel}
          htmlFor='password'
        >
          New Password
        </Typography>
        <PasswordField
          id='password'
          fullWidth
          placeholder='*********'
          autoComplete='new-password'
          name='password'
          value={inputs.password}
          onChange={handleChange}
          helperText={errors.password}
          error={Boolean(errors.password)}
          InputProps={{ sx: { bgcolor: COLORS.grey9 } }}
        />
      </FormControl>

      <FormControl>
        <Typography
          mb={1}
          fontWeight={500}
          component={FormLabel}
          htmlFor='confirmPassword'
        >
          Re-Enter password
        </Typography>
        <PasswordField
          fullWidth
          id='confirmPassword'
          placeholder='*********'
          name='confirmPassword'
          autoComplete='new-password'
          value={inputs.confirmPassword}
          onChange={handleChange}
          helperText={errors.confirmPassword}
          error={Boolean(errors.confirmPassword)}
          InputProps={{ sx: { bgcolor: COLORS.grey9 } }}
        />
      </FormControl>

      <Button sx={{ mt: 4, alignSelf: 'center' }} color='blue' type='submit'>
        <ArrowForwardIcon htmlColor='white' />
      </Button>
    </Stack>
  );
}

const schema = yup.object({
  password: yup
    .string()
    .required()
    .min(6, 'Password must be at least 6 characters')
    .label('New Password'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

export default PasswordReset;
